import React from 'react';
import { useTranslate } from '@hooks';
import { FormGroup, Label } from 'reactstrap';
import { User as UserIcon, Lock as LockIcon } from 'react-feather';
import { Form, InputGroup, Button, NextLink, PasswordInput } from '@dotone/react-ui-core';

const UserLoginForm = ({ tfaSent, onSubmit, loading, type }) => {
  const { t, tShared } = useTranslate('login');

  return (
    <Form id="loginform" className="p-4 border rounded-lg" onSubmit={onSubmit}>
      <h2>{t(`tabs.${type}`)}</h2>
      <hr className="mb-4" />
      {tfaSent ? (
        <FormGroup>
          <Label for="tfaCode">{t('tfaCode')}</Label>
          <InputGroup
            name="tfaCode"
            size="lg"
            icon={<LockIcon />}
            inputProps={{
              id: 'tfaCode',
              name: 'tfaCode',
              placeholder: t('tfaCode'),
              rules: {
                required: true,
              },
            }}
          />
        </FormGroup>
      ) : (
        <>
          <FormGroup>
            <Label for="loginInfo">{t('loginInfo')}</Label>
            <InputGroup
              name="email"
              size="lg"
              prepend={<UserIcon />}
              inputProps={{
                placeholder: tShared('loginInfo'),
                rules: {
                  required: true,
                },
              }}
            />
          </FormGroup>
          <FormGroup>
            <Label for="password">{t('password')}</Label>
            <PasswordInput
              name="password"
              size="lg"
              inputProps={{
                type: 'password',
                login: true,
                placeholder: tShared('password'),
                rules: {
                  required: true,
                },
              }}
            />
          </FormGroup>
          {type === 'network' && (
            <div className="text-right mt-n2 mb-3">
              <NextLink href="/advertisers/password/reset" className="text-dark">
                {t('forgotPassword')}?
              </NextLink>
            </div>
          )}
        </>
      )}
      <FormGroup>
        <Button color="primary" size="lg" type="submit" block submitting={loading}>
          {t(tfaSent ? 'verify' : 'submit')}
        </Button>
      </FormGroup>
      {type === 'network' && (
        <div className="text-center py-3">
          {t('joinPrompt')} <NextLink href="/advertisers/register">{t('join')}</NextLink>
        </div>
      )}
    </Form>
  );
};

export default UserLoginForm;
